// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"0d2a741e79fec2028fa5","691":"a11415704764006c5222","954":"186dc7ad24dbb2e59f45"}[chunkId] + ".js";
};